import { api } from 'common';

const FilterOperator = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterOperator;
const FilterMatchRule = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterMatchRule;
const CaseSensitivity = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.CaseSensitivity;

export const FILTER_BLOCK_OPERATOR_NAMES: Record<keyof typeof FilterOperator, string> = {
  [FilterOperator.Equals]: 'equals',
  [FilterOperator.NotEquals]: 'does not equal',
  [FilterOperator.Contains]: 'contains',
  [FilterOperator.DoesNotContain]: 'does not contain',
  [FilterOperator.GreaterThan]: 'is greater than',
  [FilterOperator.GreaterThanOrEqualTo]: 'is greater than or equal to',
  [FilterOperator.LessThan]: 'is less than',
  [FilterOperator.LessThanOrEqualTo]: 'is less than or equal to',
  [FilterOperator.IsOneOf]: 'is one of',
  [FilterOperator.IsNotOneOf]: 'is not one of',
  [FilterOperator.StartsWith]: 'starts with',
  [FilterOperator.EndsWith]: 'ends with',
  [FilterOperator.IsEmpty]: 'is empty',
  [FilterOperator.IsNotEmpty]: 'is not empty',
};

export const FILTER_BLOCK_CASE_SENSITIVITY_NAMES: Record<keyof typeof CaseSensitivity, string> = {
  [CaseSensitivity.ExactMatch]: 'Exact Match',
  [CaseSensitivity.IgnoreCase]: 'Ignore Case',
};

export const FILTER_OPERATORS_NEED_CASE_SENSITIVITY = [
  FilterOperator.Equals,
  FilterOperator.NotEquals,
  FilterOperator.Contains,
  FilterOperator.DoesNotContain,
  FilterOperator.StartsWith,
  FilterOperator.EndsWith,
  FilterOperator.IsOneOf,
  FilterOperator.IsNotOneOf,
];

export const FILTER_BLOCK_MATCH_RULE_NAMES: Record<keyof typeof FilterMatchRule, string> = {
  [FilterMatchRule.All]: 'all',
  [FilterMatchRule.Any]: 'any',
};

export const FILTER_BLOCK_NULL_OPERATORS = [FilterOperator.IsEmpty, FilterOperator.IsNotEmpty];
